import type { JobStatus } from '@maker-toolchest/shared';
import { Select } from './Select';

interface StatusSelectProps {
  value: JobStatus | '';
  onChange: (value: JobStatus | '') => void;
}

const statusOptions = [
  { value: '', label: 'All Statuses' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'READY', label: 'Ready' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'QUEUED', label: 'Queued' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'CANCELLED', label: 'Cancelled' },
];

export function StatusSelect({ value, onChange }: StatusSelectProps) {
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as JobStatus | '')}
      options={statusOptions}
    />
  );
}
